import { Component, input, InputSignal, output, OutputEmitterRef, inject } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { NgClass, NgIf } from '@angular/common';
import { AppConfig } from '../../app.config';
import { ConnectionService } from '@services/connection-service';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { DoctorProfile } from '@cureskin/api-client-rn';

@Component({
  selector: 'app-regimen-doctor-details-card',
  imports: [
    CsIconModule,
    NgIf,
    NgClass,
  ],
  templateUrl: './regimen-doctor-details-card.component.html',
  standalone: true
})
export class RegimenDoctorDetailsCardComponent {
  protected readonly appConfig: AppConfig = inject(AppConfig);
  protected readonly conn: ConnectionService = inject(ConnectionService);
  protected readonly userAllocatedDoctorService = inject(UserAllocatedDoctorService);

  user: InputSignal<any> = input();
  regimen: InputSignal<any> = input();
  allocatedDoctor: InputSignal<DoctorProfile> = input();
  reportPageView?: InputSignal<boolean> = input();
  regimenRehaulV3Exp?: InputSignal<{ product_order: "normal" | "inverse"  }> = input();
  readMoreClick: OutputEmitterRef<void> = output();

  readMoreAboutDoctor(): void {
    if (!this.allocatedDoctor) return;
    this.readMoreClick.emit();
  }
}
